// ─── Shared theme context ─────────────────────────────────────────────────────
// This file is the single import point for theme context across all pages.
// Theme color tokens live in src/theme/appTheme.js — edit there to change design.
import { createContext, useContext } from "react";

export const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

// Re-export from the theme file so any file can import from here
export { DARK, LIGHT, THEMES, ALL_THEMES, DEFAULT_THEME_ID, getTheme, FONT }
  from "./theme/appTheme";
